import React, { useEffect, useRef } from "react";
import Plotly from "plotly.js-dist";

const SalesBoxplot = ({ modelSales }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Данные AGYM за 2023, 2024, 2025 (перенесены внутрь useEffect, чтобы не пересоздавались при каждом рендере)
    const agSales23 = [
      26735485, 26538413, 20581144, 19259879, 20343917, 17789947, 16615240,
      22197891, 61950042, 25946730, 30028856, 35403025, 38892355, 32476996,
    ];
    const agSales24 = [
      28820002, 29691727, 22996706, 21539188, 23895244, 20964947, 22209142,
      24792403, 67816098, 32040374, 36046581, 40270081, 42585683, 37262234,
    ];
    const agSales25 = [
      73768500, 35005500, 39804300, 43739100, 45927000, 41691600, 32706000,
      25647300, 24011100, 25881300, 23389200, 24533100, 27431100, 31511700,
    ];

    const trace1 = {
      y: agSales23,
      type: "box",
      name: "AGYM 2023 г",
      boxpoints: "suspectedoutliers",
      jitter: 0.3,
      pointpos: -1.8,
      fillcolor: "rgba(192, 192, 192, 0.5)",
      marker: { outliercolor: "rgb(255, 0, 0)", outliersize: 8, opacity: 0.8 },
      line: { color: "rgb(0, 0, 0)", width: 2 },
    };
    const trace2 = { ...trace1, y: agSales24, name: "AGYM 2024 г" };
    const trace3 = { ...trace1, y: agSales25, name: "AGYM 2025 г" };
    const trace4 = {
      y: modelSales,
      type: "box",
      name: "Модель ≥ 2026 г",
      boxpoints: "suspectedoutliers",
      jitter: 0.3,
      pointpos: -1.8,
      fillcolor: "rgba(105, 105, 105, 0.5)",
      marker: { color: "rgb(0, 0, 0)", size: 5 },
      line: { color: "rgb(0, 0, 0)", width: 2 },
    };

    const layout = {
      title: {
        text: "Сравнение продаж по картам",
        font: { family: "Montserrat, sans-serif", size: 16, weight: "bold" },
      },
      yaxis: {
        title: {
          text: "Сумма продаж по картам в год",
          font: { family: "Montserrat, sans-serif" },
        },
        tickfont: { family: "Montserrat, sans-serif" },
        gridcolor: "#eee",
      },
      xaxis: {
        tickmode: "array",
        tickvals: [0, 1, 2, 3],
        ticktext: [
          "AGYM 2023 г",
          "AGYM 2024 г",
          "AGYM 2025 г",
          "Модель ≥ 2026 г",
        ],
        tickangle: 0,
      },
      paper_bgcolor: "rgba(0,0,0,0)",
      plot_bgcolor: "rgba(0,0,0,0)",
      margin: { t: 50, r: 30, b: 80, l: 80 },
      showlegend: false,
    };

    // Сохраняем текущий DOM элемент в переменную для cleanup
    const currentContainer = containerRef.current;
    if (currentContainer) {
      Plotly.newPlot(
        currentContainer,
        [trace1, trace2, trace3, trace4],
        layout,
        { responsive: true },
      );
    }

    return () => {
      if (currentContainer) {
        Plotly.purge(currentContainer);
      }
    };
  }, [modelSales]); // Зависимость только от modelSales

  return <div ref={containerRef} style={{ width: "100%", height: "400px" }} />;
};

export default SalesBoxplot;
